import BlogLayout from "../BlogLayout";

const Placeholder = ({ title, emoji }) => (
  <BlogLayout title={title} emoji={emoji}>
    <p>Coming soon! This section is still under construction 🛠️</p>
  </BlogLayout>
);

export default Placeholder;